import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import { LuckyTurnipsActions } from './LuckyTurnipsActions';
import { luckyTurnipsLoot, STAR_CHEST_TIER_DATA } from '../../Constants/Chests';
import { ILuckyTurnipsState } from './ILuckyTurnipsState';
import { IGameState } from '../Game/IGameState';
import { Immutable } from '../../Utility/Types';
import { ArrayHelper } from '../../Utility/ArrayHelper';

const initialLuckyTurnipsState: Immutable<ILuckyTurnipsState> = {
    pickedLootIndices: [],
    starChestTier: -1,
    lootOrder: [],
};

export function initializeLuckyTurnipsState(
    starChestTier: number,
    deserialized: ILuckyTurnipsState | null,
): ILuckyTurnipsState {
    if (deserialized) {
        if (deserialized.pickedLootIndices.length > 0) {
            return doRemainingPicksForUser(deserialized);
        }

        return deserialized;
    }

    return {
        ...initialLuckyTurnipsState,
        pickedLootIndices: [],
        starChestTier,
        lootOrder: getShuffledLootOrder(),
    };
}

function doRemainingPicksForUser(luckyTurnipsState: ILuckyTurnipsState) {
    const pickedLootIndices = [...luckyTurnipsState.pickedLootIndices];
    const picksAllowed = STAR_CHEST_TIER_DATA[luckyTurnipsState.starChestTier].luckyTurnipPicks.length;
    const picksToDo = picksAllowed - pickedLootIndices.length;

    if (picksToDo > 0) {
        pickedLootIndices.push(
            ...ArrayHelper.shuffle(
                luckyTurnipsState.lootOrder.filter(
                    lootIndex => !pickedLootIndices.includes(lootIndex),
                ),
            ).slice(0, picksToDo),
        );
    }

    return { ...luckyTurnipsState, pickedLootIndices };
}

export function getShuffledLootOrder() {
    return ArrayHelper.shuffle(ArrayHelper.range(0, luckyTurnipsLoot.length - 1));
}

export const LuckyTurnipsReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof LuckyTurnipsActions>,
): IGameState => {
    return state;
};
